// Selecciona todos los elementos con el selector dado
  const menuItems = document.querySelectorAll("summary .menu-drawer__menu-item.menu-drawer__menu-item--main");
  
  menuItems.forEach(item => {
    item.addEventListener("click", () => {
      // Encuentra el elemento padre .menulateralpro del elemento en el que se hizo clic
      const parentElement = item.closest('.menulateralpro');
  
      // Si el elemento padre ya tiene la clase "mostrarlo", no hacemos nada
      if (parentElement.classList.contains("mostrarlo")) {
        return;
      }
  
      // Primero, eliminamos la clase de cualquier otro .menulateralpro que la tenga
      document.querySelectorAll(".menulateralpro.mostrarlo").forEach(otherParent => {
        otherParent.classList.remove("mostrarlo");
      });
  
      // Luego, agregamos la clase al elemento actual
      parentElement.classList.add("mostrarlo");
    });
  });
  
  if (window.innerWidth > 900) {
    menuItems[0].click()
  }

  document.addEventListener('DOMContentLoaded', () => {
          document.querySelectorAll('.atras-back').forEach(element => {
              element.addEventListener('click', () => {
                  document.querySelectorAll('.mostrarlo').forEach(mostrarloElement => {
                      mostrarloElement.classList.remove('mostrarlo');
                  });
              });
          });
  });



function addToCart(event, variantId) {
    event.preventDefault(); // Evita la redirección por defecto
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
    .then(response => response.json())
    .then(data => {
        console.log("Producto agregado al carrito:", data);
        // Recarga la página para actualizar el carrito
        localStorage.setItem('openCartAfterReload', 'true');
        location.reload();
    })
    .catch(error => console.error("Error al agregar el producto al carrito:", error));
}

// Detecta la recarga y simula el clic en el ícono del carrito
document.addEventListener("DOMContentLoaded", function() {
    if (localStorage.getItem('openCartAfterReload') === 'true') {
        localStorage.removeItem('openCartAfterReload');
        document.getElementById('cart-icon-bubble').click();
    }
});


function applyZoom() {
  const baseWidth = 1460; // Ancho base en píxeles

  if (window.innerWidth > baseWidth) {
    // Calcula y aplica el nivel de zoom si el ancho es mayor al baseWidth
    const zoomLevel = window.innerWidth / baseWidth;
    document.body.style.zoom = zoomLevel;
  } else {
    // Restablece el zoom a 1 si el ancho es menor o igual al baseWidth
    document.body.style.zoom = 1;
  }
}

// Aplica el zoom inicial al cargar la página
applyZoom();

// Escucha los cambios de tamaño de la ventana y ajusta el zoom en tiempo real
window.addEventListener('resize', applyZoom);




document.addEventListener("DOMContentLoaded", function () {
  console.log("aaaaa")
    // Verificamos si existen los elementos #reviews-wrapper y #reviews

    // Si ambos existen, movemos #reviews-wrapper como hijo de #reviews
    let intentos = 0;
    const bucle = () => {
      const reviewsWrapper = document.querySelector("#reviews-wrapper");
      const reviews = document.querySelector("#reviews");
      
      intentos++
      if (reviewsWrapper && reviews) {
          reviews.appendChild(reviewsWrapper);
      }  
      else if(intentos < 10) {
        // console.log(intentos)
        setTimeout(() => {
          bucle()
        }, 100);
      }
    }

  bucle()
});


document.addEventListener("DOMContentLoaded", function () {
  const coloridoElements = document.querySelectorAll('.colorido');
    
    // Asignar evento click a cada elemento .colorido
    coloridoElements.forEach(element => {
      element.addEventListener('click', () => {

        const menuOpening = document.querySelector('.bbbbb details.menu-opening');
        const menuOpeningColors = document.querySelector('.aaaaa details.menu-opening');
        
        if (menuOpening) {
          const closeButton = menuOpening.querySelector('.bbbbb button.menu-drawer__close-button.close-menu-js');
          if (closeButton) {
            closeButton.click();
          }
        } 

        setTimeout(() => {
          if (!menuOpeningColors) {
            document.querySelector(".aaaaa details summary").click()
          } 
        }, 300);



        // Acción principal después de verificar
        console.log('Acción principal ejecutada para:', element.textContent.trim());
      });
    });

  const categoriasElements = document.querySelectorAll('.categorias');
    
    // Asignar evento click a cada elemento .colorido
    categoriasElements.forEach(element => {
      element.addEventListener('click', () => {

        const menuOpening = document.querySelector('.aaaaa details.menu-opening');
        const menuOpeningCategorias = document.querySelector('.bbbbb details.menu-opening');
        
        if (menuOpening) {
          const closeButton = menuOpening.querySelector('.aaaaa button.menu-drawer__close-button.close-menu-js');
          if (closeButton) {
            closeButton.click();
          }
        } 

        setTimeout(() => {
          if (!menuOpeningCategorias) {
            document.querySelector(".bbbbb details summary").click()
          } 
        }, 300);



        // Acción principal después de verificar
        console.log('Acción principal ejecutada para:', element.textContent.trim());
      });
    });



    // Verificar si la resolución es menor a 700px
    if (window.innerWidth < 700) {
      // Seleccionar todos los elementos .menulateralpro summary
      const summaries = document.querySelectorAll('.menulateralpro summary');
    
      // Asignar evento click a cada summary
      summaries.forEach(summary => {
        summary.addEventListener('click', () => {
          // Obtener el padre del summary
          const parent = summary.parentElement;
          if (parent) {
            // Buscar el primer enlace (<a>) dentro del padre
            const firstLink = parent.querySelector('a');
            if (firstLink) {
              // Simular clic en el enlace
              firstLink.click();
              console.log(`Redirigiendo a: ${firstLink.href}`);
            }
          }
        });
      });
    }


});


